// @flow strict

import * as React from 'react';

function SubscriptionsCataloguePage() {
    return (
        <div className="p-6">
            <h1 className="font-poppins font-semibold text-[18px] text-title mb-4">
                Catalogue d'Abonnements
            </h1>
            <p className="font-nunito text-[14px] text-text">
                Explorez nos différentes formules d'abonnement adaptées à vos besoins.
            </p>
        </div>
    );
};

export default SubscriptionsCataloguePage;